export default __webpack_public_path__ + "static/media/carNameR.a55b6839.png";